import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(): null {
  const { pathname, key } = useLocation();
  const prevKey = useRef<string>(key);
  const positions = useRef<Record<string, number>>({});

  useEffect(() => {
    // Ruaj pozicionin e faqes aktuale para se të largohesh
    const handleScroll = () => {
      positions.current[prevKey.current] = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Kontro nëse ka pozicion të ruajtur (kthim mbrapa)
    const saved = positions.current[key];
    if (saved !== undefined) {
      // Kthim mbrapa — restauro pozicionin
      requestAnimationFrame(() => {
        window.scrollTo({ top: saved, behavior: "instant" });
      });
    } else {
      // Navigim i ri — shko në krye
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    prevKey.current = key;
  }, [pathname, key]);

  return null;
}
